import { IPricingRecord } from "@services/QuoteBuilder/QuoteBuilderService";

export type PricingRecordAction =
  | {
      type: "UPDATE_FIELD";
      payload: {
        field: string;
        value: any;
      };
    }
  | {
      type: "SET_PRICING_RECORD";
      payload: IPricingRecord | null;
    }
  | {
      type: "INCLUDE_PRICING_RECORD_DETAIL";
      payload: number | null | undefined;
    }
  | {
      type: "EXCLUDE_PRICING_RECORD_DETAIL";
      payload: number | null | undefined;
    };

export function pricingRecordReducer(
  state: IPricingRecord | null,
  action: PricingRecordAction
): IPricingRecord | null {
  switch (action.type) {
    case "EXCLUDE_PRICING_RECORD_DETAIL":
      if (state) {
        const lineItems = state.pricing_record_line_items.map((lineItem) =>
          lineItem.pricing_template_line_item_id === action.payload
            ? { ...lineItem, included: false }
            : lineItem
        );

        return { ...state, pricing_record_line_items: lineItems };
      }

      return state;

    case "INCLUDE_PRICING_RECORD_DETAIL":
      if (state) {
        const lineItems = state.pricing_record_line_items.map((lineItem) =>
          lineItem.pricing_template_line_item_id === action.payload
            ? { ...lineItem, included: true }
            : lineItem
        );

        return { ...state, pricing_record_line_items: lineItems };
      }

      return state;

    case "SET_PRICING_RECORD":
      return action.payload;

    case "UPDATE_FIELD":
      console.log(
        `Updating ${action.payload.field} in CustomerPotentialDetail with: ${action.payload.value}`
      );
      if (state) {
        return {
          ...state,
          [action.payload.field]: action.payload.value,
        };
      }
      return state;

    default:
      console.log(`Error - incorrect action sent ${action} ${state}`);
      return state;
  }
}
